/**
 * React Query Configuration
 *
 * TanStack Query client setup with default options
 */

import { QueryClient } from '@tanstack/react-query';

/**
 * Configured QueryClient instance
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    },
    mutations: {
      retry: 0,
    },
  },
});
